import { useCallback, useEffect, useState } from 'react'

type CountdownOptions = {
  countStart: number
}

type Countdown = {
  count: number
  startCountdown: () => void
  stopCountdown: () => void
  resetCountdown: () => void
}

export function useCountdown({ countStart }: CountdownOptions): Countdown {
  const [isCountdownRunning, setIsCountdownRunning] = useState(false)
  const [count, setCount] = useState(countStart)

  const startCountdown = useCallback(() => setIsCountdownRunning(true), [])

  const stopCountdown = useCallback(() => setIsCountdownRunning(false), [])

  const resetCountdown = useCallback(() => {
    stopCountdown()
    setCount(countStart)
  }, [countStart, stopCountdown, setCount])

  useEffect(() => {
    if (!isCountdownRunning) return

    if (count === 0) {
      return resetCountdown()
    }

    const timeout = setTimeout(() => setCount(count - 1), 1000)

    return () => clearTimeout(timeout)
  }, [isCountdownRunning, count, resetCountdown])

  return { count, startCountdown, stopCountdown, resetCountdown }
}
